<script setup lang="ts">
import type { NotificationType } from '@/types/ui';
import { computed } from 'vue';

const { text, type, duration } = defineProps<{
    duration: number;
    type: NotificationType;
    text: string;
}>();

const classes = computed<string[]>(() => {
    const tmp: string[] =  [];

    tmp.push(`notification--${type}`);

    return tmp;
});
</script>

<template>
<div class="notification" :class="classes">
    <div>{{ text }}</div>
    <div class="notification__time-indicator" :style="`animation-duration: ${duration / 1000}s;`"></div>
</div>
</template>
